$(function(){
  $('.product_image_slider').slick({
    autoplay: true,
    autoplaySpeed: 4500,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product_text_slider',
    centerMode: true,
    centerPadding: 0
  });

  $('.product_text_slider').slick({
    // autoplay: true,
    // slidesToShow: ,
    asNavFor: '.product_image_slider',
    arrows: false,
    fade: true
  });


});
